function userRole(user, orgId) {
  const metadata = user['https://vrpatients.com/app_metadata'] || user.app_metadata;
  if (!user || !metadata || !orgId) {
    return undefined;
  }
  return metadata.orgSpecificRoles && metadata.orgSpecificRoles[orgId]
    ? metadata.orgSpecificRoles[orgId]
    : metadata.role;
}

module.exports = userRole;
